import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import {DrawSchema, DrawSchemaWithFabricObject} from '../_interface/schema.model';
import {DocumentationDrawSchemaFileDto} from 'app/_models/model/documentationDrawSchemaFileDto';
import {JournalEditMode} from '../../../_interface/journal-edit-mode.enum';

export const createSchemaForEditFromEvent = createAction(
	'[Schema 🎁] Create schema for edit from event',
	props<{ event: Event, readStream: string }>()
);

export const setSchemaForEdit = createAction(
	'[Schema 🎁] Set schema for edit',
	props<{ schema: Partial<DrawSchema> }>()
);

export const cancelSchemaForEdit = createAction(
	'[Schema 🎁] Cancel schema edit'
);

export const initLoadSchemas = createAction('[Schema 🎁] Init Load Schemas');

export const initConvertSchemasToDrawObject = createAction(
	'[Schema 🎁] Init converting schemas to draw object type',
	props<{ schemas: DocumentationDrawSchemaFileDto[] }>());

export const convertSchemasToDrawObject = createAction(
	'[Schema 🎁] Convert schemas to draw object type',
	props<{ fabricObjects: DrawSchemaWithFabricObject[] }>());

export const cannotConvertSchemasToDrawObject = createAction(
	'[Schema 🎁] Cannot convert schemas to draw object',
	props<{ error: any }>());

export const noSchemas = createAction('[Schema 🎁] Cannot get schemas');

export const loadSchemas = createAction(
	'[Schema 🎁] Load Schemas',
	props<{ schemas: DrawSchema[] }>()
);

export const addSchema = createAction(
	'[Schema 🎁] Add Schema',
	props<{ schema: DrawSchema }>()
);

export const tryUpsertSchema = createAction(
	'[Schema 🎁] Try to upsert Schema',
	props<{schema: Partial<DrawSchema>}>()
);

export const upsertSchema = createAction(
	'[Schema 🎁] Upsert Schema',
	props<{ schema: DrawSchema }>()
);

export const addSchemas = createAction(
	'[Schema 🎁] Add Schemas',
	props<{ schemas: DrawSchema[] }>()
);

export const upsertSchemas = createAction(
	'[Schema 🎁] Upsert Schemas',
	props<{ schemas: DrawSchema[] }>()
);

export const updateSchema = createAction(
	'[Schema 🎁] Update Schema',
	props<{ schema: Update<DrawSchema> }>()
);

export const updateSchemas = createAction(
	'[Schema 🎁] Update Schemas',
	props<{ schemas: Update<DrawSchema>[] }>()
);

export const tryDeleteSchema = createAction('[Schema 🎁] Delete Schema', props<{ id: string }>());

export const deleteSchemaSuccess = createAction(
	'[Schema 🎁] Delete Schema success',
	props<{ id: string }>()
);

export const deleteSchemaError = createAction('[Schema 🎁] Delete Schema failure');

export const deleteSchemas = createAction(
	'[Schema 🎁] Delete Schemas',
	props<{ ids: string[] }>()
);

export const clearSchemas = createAction(
	'[Schema 🎁] Clear Schemas'
);

export const changeSchemaMode = createAction('[Schema 🎁] Schema mode changed', props<{mode: JournalEditMode}>());


